import React from 'react';
import { MdClose } from 'react-icons/md';

/**
 * Shared modal chrome so every popup reads the same: an 800-weight title, a
 * circular ghost close, a divided footer, and accent/ghost/danger actions.
 */

export const ModalHeader = ({ title, subtitle, onClose, leading }) => (
  <div className="modal-header">
    {leading}
    <div className="modal-header-text">
      <div className="modal-title">{title}</div>
      {subtitle && <div className="modal-subtitle">{subtitle}</div>}
    </div>
    {onClose && (
      <button type="button" className="modal-close" onClick={onClose} title="Close">
        <MdClose size={16} />
      </button>
    )}
  </div>
);

export const ModalBody = ({ children, scroll = false, style }) => (
  <div className={`modal-body ${scroll ? 'is-scroll' : ''}`} style={style}>
    {children}
  </div>
);

export const ModalFooter = ({ children, note }) => (
  <div className="modal-footer">
    {note && <span className="modal-footer-note">{note}</span>}
    <div className="modal-footer-actions">{children}</div>
  </div>
);

/** variant: 'accent' | 'ghost' | 'danger' | 'quiet' */
export const ModalButton = ({ variant = 'ghost', children, ...rest }) => (
  <button type="button" {...rest} className={`modal-btn is-${variant} ${rest.className || ''}`}>
    {children}
  </button>
);

/** Segmented control used to switch a modal between modes. */
export const ModalTabs = ({ tabs, value, onChange }) => (
  <div className="modal-tabs">
    {tabs.map((t) => (
      <button
        key={t.value}
        type="button"
        className={`modal-tab ${value === t.value ? 'is-active' : ''}`}
        onClick={() => onChange(t.value)}
      >
        {t.label}
      </button>
    ))}
  </div>
);
